import React, { useState, useEffect } from "react";
import "./WeatherForecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
  let [forecastloaded, setForecastloaded] = useState(false);
  let [forecast, setForecast] = useState(null);
  useEffect(() => {
    setForecastloaded(false);
  }, [props.coordinates, props.selectedUnit]);

  function handleResponse(response) {
    setForecast(response.data.daily);
    setForecastloaded(true);
  }

  if (forecastloaded) {
    return (
      <div className="WeatherForecast">
        <div className="row">
          {forecast.map(function (dailyforecast, index) {
            if (index > 0 && index < 6) {
              return (
                <div className="col" key={index}>
                  <WeatherForecastDay
                    data={dailyforecast}
                    units={props.currentUnit}
                  />
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  } else {
    let apikey = "8161b4309ee03faae957729ba7104797";
    let longitude = props.coordinates.lon;
    let latitude = props.coordinates.lat;
    let unit = props.selectedUnit;
    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&units=${unit}&appid=${apikey}`;
    axios.get(apiUrl).then(handleResponse);
    return null;
  }
}
